<div [class]="cardClass">
  <div class="banner-card__accent"></div>
  <div class="banner-card__body">
    @if (dismissible()) {
      <button
        class="banner-card__dismiss"
        type="button"
        aria-label="Close"
        (click)="dismiss.emit()"
      >
        <umss-icon name="phosphorX" size="16px" />
      </button>
    }
    <div class="banner-card__header">
      <umss-icon [name]="resolvedIconName" [color]="iconColor" />
      <p class="pg-medium">{{ title() }}</p>
    </div>
    @if (message()) {
      <p class="pg-small-medium banner-card__message">{{ message() }}</p>
    }
    @if (showButton()) {
      <div class="banner-card__action">
        <umss-button
          [label]="buttonLabel()"
          [variant]="buttonVariant()"
          [leftIconName]="buttonIconName()"
          [loading]="buttonLoading()"
          (onClick)="buttonClick.emit()"
        />
      </div>
    }
    <ng-content />
  </div>
</div>
